import { render, staticRenderFns } from "./ReviewMeetingActionItems.vue?vue&type=template&id=8d2680a4&"
import script from "./ReviewMeetingActionItems.vue?vue&type=script&lang=ts&"
export * from "./ReviewMeetingActionItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports